import { useEffect, useState } from 'react'
import Footer from '../components/Footer/Footer'
import InsightForm from '../components/InsightForm/InsightForm';
import InsightCard from '../components/InsightCard/InsightCard';
import { useDispatch, useSelector } from 'react-redux';
import { deleteInsight, fetchInsights } from '../features/insight/insightActions';
import { Container, Row } from 'react-bootstrap';
import Buttonfilled from '../components/Buttonfilled/Buttonfilled';
import { Helmet } from 'react-helmet';

const AdminInsight = () => {
  const dispatch = useDispatch();
  const { insights, loading, error } = useSelector((state) => state.insights);
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);
  const [formData, setFormData] = useState(null);

  useEffect(() => {
    dispatch(fetchInsights());
  }, [dispatch]);
  const handleLogout = () => {
    localStorage.removeItem("userInfo"); // remove saved admin info
    window.location.href = "/admin";      // redirect to login page
  };

  const handleEdit = (insight) => {
    setEditId(insight.insight_id);
    setFormData(insight);
    setShowForm(true);
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this insight?")) {
      dispatch(deleteInsight(id));
      dispatch(fetchInsights());
    }
  };
  return (
    <div >
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
      <Container style={{ fontFamily: "arial", minHeight: "52vh" }} className="py-4">
        <div className="d-flex justify-content-between mb-3">
          <h2 className="fw-bold">Admin insight Management</h2>
          <Buttonfilled
            text={showForm ? "Close Form" : "Create New insight"}
            onClick={() => {
              if (showForm) {
                setShowForm(false);
                setFormData(null);
                setEditId(null);
              } else {
                setFormData({
                  title: "",
                  metaTitle: "",
                  metaDescription: "",
                  slug_url: "",
                  brief_paragraph: "",
                  insight_image: "",
                  published_date: "",
                  category: "",
                  insights_content: [{ heading: "", paragraph: "" }, { quote: "" }, { heading: "", paragraph: "" }, { heading: "", paragraph: "" }, { heading: "", paragraph: "" },],
                });
                setShowForm(true);
              }
            }}
          />
          <Buttonfilled
            text="Logout"
            onClick={handleLogout}
          />
        </div>

        {showForm && (
          <InsightForm
            formData={formData}
            setFormData={setFormData}
            editId={editId}
            setEditId={setEditId}
            setShowForm={setShowForm}
          />
        )}

        {loading && <p>Loading insights...</p>}

        {error && <p className="text-danger">{error}</p>}

        {!loading && insights?.length > 0 && (
          <Row className="g-4">
            {insights.map((insight) => (
              <InsightCard
                key={insight._id}
                insight={insight}
                handleEdit={handleEdit}
                handleDelete={handleDelete}
              />
            ))}
          </Row>
        )}

        {!loading && insights?.length === 0 && (
          <p className="text-muted text-center mt-4">No insights found.</p>
        )}
      </Container>
      <Footer />
    </div>
  )
}

export default AdminInsight